var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5402 8.23413H16.4598C11.9165 8.23413 8.23413 11.9171 8.23413 16.4598V30.5402C8.23413 35.0835 11.9171 38.7659 16.4604 38.7659H30.5395C35.0829 38.7659 38.7659 35.0829 38.7659 30.5395V16.4598C38.7659 11.9165 35.0835 8.23413 30.5402 8.23413Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 30.8699C27.5703 30.8699 30.8699 27.5703 30.8699 23.5C30.8699 19.4297 27.5703 16.1301 23.5 16.1301C19.4297 16.1301 16.1301 19.4297 16.1301 23.5C16.1301 27.5703 19.4297 30.8699 23.5 30.8699Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4489 16.1302C33.321 16.1302 34.028 15.4232 34.028 14.5511C34.028 13.679 33.321 12.972 32.4489 12.972C31.5768 12.972 30.8699 13.679 30.8699 14.5511C30.8699 15.4232 31.5768 16.1302 32.4489 16.1302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.16e4af0bc3908f9ef02ddb41839bfbef.svg";
export { ForwardRef as ReactComponent };